export const countLoginBackgroundDefault = 4
export const countLoginBackgroundSpecial = 2
export const countBannerHome = 1